import {Flex, Layout, Select, Space} from 'antd';
import DeviceSelector from "./DeviceSelector/DeviceSelector";
import OrderQueue from "./OrderQueue/OrderQueue";

const Orders = ({ user }) => {

  const accountId = user.account._id;
  const siteId = "627bb4055a278e4aa0d77d84"; // Park 2

  return (
    <Layout style={{ background: 'white' }}>
      <Space direction="vertical" size={24}>
        <div style={{
          color: '#383838',
          fontFamily: 'Inter',
          fontSize: 20,
          fontWeight: 600,
          }}>
          Orders
        </div>
        <DeviceSelector/>
        <OrderQueue/>
      </Space>


    </Layout>
  );
}

export default Orders;



const OrderCard = ({dispensingOrder}) => {

}
